<template>
  <div class="banner relative">
    <!--轮播图-->
    <el-carousel
        ref="bannerRef"
        :autoplay="true"
        trigger="click"
        arrow="never"
        indicator-position="none"
        :interval="interval"
        :pause-on-hover="false"
        @change="changeBanner"
    >
      <el-carousel-item v-for="(item,index) in banner" :key="index" class="cursor">
        <template>
          <a class="banner-img" :href="item.link ? item.link : 'javascript:;'"
             :target="item.link ? '_blank' : '_self'" rel="noopener">
            <img :src="item.picUrl" alt="">
          </a>
        </template>
      </el-carousel-item>
    </el-carousel>
    <!--指示器-->
    <div class="content-1200 indicator">
      <div v-if="banner.length > 1" class="indicator-box flex absolute">
        <div
            v-for="(item,index) in banner"
            :key="index"
            :class="['indicator-item',{active: index === activeIndex}]"
            :style="animateTimeStyle"
            @mouseenter="changeIndicator(index)"
        >
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    banner: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      interval: 3000,
      activeIndex: 0, // 当前指示器高亮
    }
  },
  computed: {
    // 动画时长
    animateTimeStyle() {
      return {'--animation-duration': `${this.interval / 1000}s`}
    }
  },
  watch: {
    banner() {
      this.activeIndex = 0
    }
  },
  methods: {
    changeBanner(current) {
      this.activeIndex = current
    },
    // 点击指示器
    changeIndicator(index) {
      this.activeIndex = index
      this.$refs.bannerRef?.setActiveItem(index)
    }
  }
}
</script>
<style lang="scss" scoped>
.banner {
  height: 600px;
  /deep/.el-carousel,/deep/.el-carousel__container {
    height: 100%;
  }
}
.banner-img {
  width: 100%;
  height: 100%;
  display: inline-block;
  position: relative;

  img {
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    object-fit: cover !important;
  }
}

.indicator {
  position: relative;
  bottom: 41px;

  .indicator-box {
    z-index: 99;
    left: 50%;
    transform: translateX(-50%);

    .indicator-item {
      border-radius: 21px 21px 21px 21px;
      transition: width linear 0.4s;
      background-color: #333333;
      overflow: hidden;
      height: 6px;
      width: 32px;
      cursor: pointer;
      margin-right: 8px;

      &:after {
        content: "";
        display: inline-block;
        width: 100%;
        position: absolute;
        z-index: 2;
        transition: width linear 0.4s;
      }

      &.active {
        background-color: #CEC298;
        width: 54px;
        position: relative;

        &:after {
          content: "";
          width: 100%;
          height: 100%;
          background-color: #333;
          position: absolute;
          left: 0;
          -webkit-animation: a var(--animation-duration) linear forwards;
          animation: a var(--animation-duration) linear forwards;
        }

      }
    }
  }
}


@keyframes a {
  0% {
    left: 0
  }

  to {
    left: 100%
  }
}
</style>
